module.exports = __webpack_public_path__ + "static/media/calendar_squeeze.a44d1d04.jpg";